import { useEffect, useState } from "react";
import { errorLogger } from "@/Common/helpers/logger";
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import ACTIONS from "@/Constants/actionsList";
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import { Box, Grid, List, ListItemText } from "@mui/material";
import { useMutation } from "@tanstack/react-query";

const GlobalRanking = (props: { locationId: string; isGlobalRanking?: boolean }) => {
	const { locationId, isGlobalRanking = false } = props;
	const { useAuth } = useAuthorization();
	const FAndIRankingAction = useAuth(ACTIONS["EDIT_F&I_RANKING"]);
	const [isChecked, setIsChecked] = useState(false);

	const { mutate, isPending } = useMutation({
		mutationFn: (input: { isGlobalRanking: boolean }) => updateSystemSettings(locationId, input, "FI_RANKING_TYPE"),
		onError: (error) => errorLogger(error),
	});

	const handleCheck = () => {
		setIsChecked(!isChecked);
		mutate({ isGlobalRanking: !isChecked });
	};

	useEffect(() => {
		setIsChecked(isGlobalRanking);
	}, [isGlobalRanking]);

	return (
		<Box>
			<List sx={{ padding: 0 }} className="!mb-[12px]">
				<ListItemText
					primary="F&I Ranking"
					secondary="Setting that defines whether F&I Rankings will use local or global ranking data."
					primaryTypographyProps={{ className: "text-gray-text" }}
					secondaryTypographyProps={{ className: "text-gray-text" }}
				/>
			</List>
			<Grid container>
				<Grid item sx={{ position: "relative" }}>
					<CustomizedSwitches
						disabled={!FAndIRankingAction || isPending}
						textRight
						textUnChecked="Local Only"
						textChecked="Global Only"
						onChange={handleCheck}
						checked={isChecked}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

export default GlobalRanking;
